<template>
    <Modal :id="'cmp-distribution-order-check_barcode_modal'" @cancelled="onCancel">
        <template slot="header">{{ $t('barcode_errors_remaining') }}</template>
        <template slot="body">

            <NTable class="distribution-order-check_barcode_modal" :items="orderLines" :config="createNTableConfig({
                rowHeight: 30,
                headerStyle: 3,
            })
                " :headers="headers" :id="'distribution-order-check_barcode_modal'">
                
                <template v-slot:item="{ item, tdcon }">
                    <tr>
                        <td v-bind="tdcon('barcode')">
                            <span>{{ item["barcode"] }}</span>
                        </td>
                        <td v-bind="tdcon('orders')">
                            <span>{{ item["orders"] }}</span>
                        </td>
                        <td v-bind="tdcon('accounts')">
                            <span>{{ item["accounts"] }}</span>
                        </td>
                        <td v-bind="tdcon('qty_ordered')">
                            <span>{{ item["qty_ordered"] }}</span>
                        </td>
                        <td v-bind="tdcon('amount')">
                            <span>{{ item["amount"] }}</span>
                        </td>

                    </tr>
                </template>
            </NTable>
        </template>
        <template slot="options">
            <button class="dt-button s6" @click.stop="onExport">
                {{ $t("export") }}
            </button>
            <div>
                <button class="dt-button v1 s6" @click.stop="onCancel">
                    {{ $t("ok") }}
                </button>
                
            </div>
        </template>
    </Modal>
</template>
  
<script>
import Modal from "@dtplugins/modal/modal";
import { createTextFieldConfig } from "../../../../plugins/text-field";
import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import { createTableHeader } from "../../../../plugins/datatable";
import { OrderService } from "../../services/order.service";
import {
    closeModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import FileDownload from "js-file-download";
export default {
    components: {
        Modal,
        NTable,
    },
    props: ['selectedEdiOrderTab'],
    async mounted() {
        const order_ids = this.selectedEdiOrderTab?.orders.map(o => o.order_id).join(',') || ''
        const res = await OrderService.checkBarcodesEdi(order_ids);
        this.orderLines = res.data.orderlines || [];
    },
    data: function () {
        return {
            textFieldConfig: createTextFieldConfig({
                height: 42,
                showEditIconOnHover: false,
                box: true,
                showValidationIcons: false,
            }),
            orderLines: [],

        };
    },
    computed: {
        headers: function () {
            return [
                createTableHeader("barcode", { f: 0.6 }),
                createTableHeader("orders", { ta: 'center' }),
                createTableHeader("accounts", { fa: 1.1 }),
                createTableHeader("qty_ordered", { text: 'QTY', mw: 100, ta: 'center' }),
                createTableHeader("amount", { mw: 100, ta: 'right' }),

            ];
        },

    },
    methods: {
        createNTableConfig: createNTableConfig,
        onSubmit() {

        },
        onCancel: function () {
            closeModalRoute(this);
        },
        onExport: async function () {
            const order_ids = this.selectedEdiOrderTab?.orders.map(o => o.order_id).join(',') || ''
            const res = await OrderService.exportEdiBarcodeCheckErrors(
                order_ids
            );
            console.log({ fileURL: res.data });
            FileDownload(
                res.data,
                `Barcode_Errors_Remaining_${new Date().toUTCString()}.xlsx`
            );
        }
        //MARK: Methods
    },
};
</script>
  
<style lang="scss">
.cmp-distribution-order-check_barcode_modal {
    .distribution-order-check_barcode_modal {
        --ntable-height: 400px;
        border: 1px solid rgba(128, 128, 128, 0.158);
        background: #f8f8f8;



    }

    .dt-modal--options {
        display: flex;
        flex-direction: row;
        justify-content: space-between !important;

        div {
            display: flex;
        }
    }
}
</style>
  